import React, { createContext, useState, useContext, useEffect } from 'react';
import { AdminSystemLocaleDto, SystemLocaleDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';

interface LocalContextType {
  initLocales: () => void;
  locale: string;
  setLocale: (locale: string) => void;
  locales?: AdminSystemLocaleDto[];
  activeLocale?: AdminSystemLocaleDto[];
}

const LocalContext = createContext<LocalContextType | undefined>(undefined);

export const LocalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locale, setLocale] = useState('ko'); // 기본 언어를 한국어로 설정
  const [locales, setLocales] = useState<AdminSystemLocaleDto[]>();
  const [activeLocale, setActiveLocale] = useState<AdminSystemLocaleDto[]>();

  const fetchLocales = async () => {
    try {
      const response = await ServiceHelper.adminLocaleService?.getLocales1();
      if (response?.data) {
        const filteredLocales = [...response.data] // 원본 배열 복사
          .filter((locale: AdminSystemLocaleDto) => locale.isActive);

        setActiveLocale(filteredLocales);
        setLocales(response.data);
      }
    } catch (error) {
      console.error('언어 데이터 로딩 실패:', error);
    }
  };

  const initLocales = async () => {
    await fetchLocales();
  };

  useEffect(() => {
    initLocales();
  }, [locale]);

  return (
    <LocalContext.Provider value={{ locale, setLocale, locales, activeLocale, initLocales }}>
      {children}
    </LocalContext.Provider>
  );
};

// 커스텀 훅 생성
export const useLocale = () => {
  const context = useContext(LocalContext);
  if (!context) {
    throw new Error('useLocale는 LocalProvider 내부에서만 사용할 수 있습니다.');
  }
  return context;
};
